import ComposeComponentProps from './ComposeComponentProps';
import RecipientPanel from './RecipientPanel';
import SubjectLine from './SubjectLine';
import { observer } from 'mobx-react';
import { ComposeControl } from 'owa-mail-compose-store';
import canModifyRecipients from 'owa-mail-compose-actions/lib/utils/canModifyRecipients';
import * as React from 'react';
import { getAllRecipients } from 'owa-mail-compose-actions/lib/utils/getAllRecipientsAsEmailAddressStrings';
import { MeetingDetails } from 'owa-meeting-message';
import { ComposeInfoBar } from 'owa-mail-compose-infobar-view';

const styles = require('./ComposeTop.scss');
const classNames = require('classnames/bind').bind(styles);

export interface ComposeTopProps extends ComposeComponentProps {
    senderPersona?: JSX.Element;
}

const composeTopRecipientPanelFocusTargets: ComposeControl[] = [
    ComposeControl.RecipientWellTo,
    ComposeControl.RecipientWellCc,
    ComposeControl.RecipientWellBcc,
];

@observer
export default class ComposeTop extends React.Component<ComposeTopProps, {}> {
    private subjectLine: SubjectLine;
    private recipientPanel: RecipientPanel;

    public trySetFocus(controlToFocus: ComposeControl): void {
        if (composeTopRecipientPanelFocusTargets.indexOf(controlToFocus) !== -1) {
            this.recipientPanel.focus(controlToFocus as (
                | ComposeControl.RecipientWellTo
                | ComposeControl.RecipientWellCc
                | ComposeControl.RecipientWellBcc));
        } else if (controlToFocus == ComposeControl.SubjectLine) {
            this.subjectLine.focus();
        }
    }

    render() {
        const { viewState, senderPersona } = this.props;
        const {
            infoBarIds,
            isInlineCompose,
            showCompactRecipientWell,
            fromViewState,
            ccRecipientWell,
            bccRecipientWell,
            meetingRequestItem,
        } = viewState;

        const containerClassName = classNames(styles.topContainer, {
            isInlineCompose: isInlineCompose,
        });

        const infoBarLength = (infoBarIds || []).length;
        const recipientCount = getAllRecipients(viewState).length;

        // There is possibly infobar existing, when
        // 1. infoBarIds.length > 0, OR
        // 2. recipient count > 0
        const possiblyHasInfoBar = infoBarLength + recipientCount > 0;

        return (
            <div className={containerClassName} key="composeTopDiv">
                {possiblyHasInfoBar && <ComposeInfoBar viewState={viewState} />}
                <RecipientPanel
                    isReadOnly={!canModifyRecipients(viewState)}
                    showCompactRecipientWell={showCompactRecipientWell}
                    isFromShown={fromViewState.isFromShown}
                    ccRecipientWell={ccRecipientWell}
                    bccRecipientWell={bccRecipientWell}
                    composeViewState={viewState}
                    onContentSizeChanged={this.onContentSizeChanged}
                    senderPersona={senderPersona}
                    ref={ref => (this.recipientPanel = ref)}
                />
                {!isInlineCompose && (
                    <SubjectLine
                        composeViewState={viewState}
                        ref={ref => (this.subjectLine = ref)}
                    />
                )}
                {meetingRequestItem && (
                    <div className={styles.meetingDetailsContainer}>
                        <MeetingDetails item={meetingRequestItem} isForward={true} />
                    </div>
                )}
            </div>
        );
    }

    private onContentSizeChanged = (delta: number, sourceElement: HTMLElement) => {
        if (this.props.plugins) {
            this.props.plugins.docking.onContentSizeChanged(delta, sourceElement);
        }
    };
}
